import src from "IMAGE";
export default { src, width: 347, height: 311, blurWidth: 0, blurHeight: 0};
